import { InputLabel, TextField } from "@material-ui/core";
import styles from "../../views/SignIn/SignIn.module.scss";
import Logo from "../../assets/images/new-logo.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import axios from "axios";

const LoginPasswordReset = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const validate = Yup.object({
		email: Yup.string()
			.email("Email is invalid")
			.required("Email Address is required"),
	});

	const handleLogin = () => {
		history.push("/signin");
	};
	const handleContinue = () => {
		history.push("/newpassword");
	};

	return (
		<Formik
			initialValues={{
				email: "",
			}}
			validationSchema={validate}
			onSubmit={(values) => {
				dispatch(openLoader());

				axios
					.post("/auth/password/reset", values)
					.then((res: any) => {
						dispatch(closeLoader());
						dispatch(
							openToastAndSetContent({
								toastContent: res?.data?.message,
								toastType: "success",
							})
						);

						history.push("/email_verification");
					})
					.catch((err: any) => {
						dispatch(closeLoader());
						dispatch(
							openToastAndSetContent({
								toastContent: err?.response?.data?.message || err.message,
								toastType: "error",
							})
						);
					});
			}}
		>
			{(props) => (
				<div className={styles.signinContainer}>
					<div className={styles.logo}>
						<img src={Logo} alt="logo" />
						<h3>Admin</h3>
					</div>
					<div className={styles.mt1}>
						<div className={styles.signinDiv}>
							<div className={styles.header}>
								<h5 className={styles.signinHeader}>Password Reset</h5>
								<p className={styles.headerP}>
									Enter the email address associated with your account and we'll
									send you a link to reset your password.
								</p>
							</div>
							<div className={styles.mt2}>
								<Form>
									<InputLabel>
										<span className={styles.formTitle}>Email Address</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="email">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="email"
										placeholder="Email Address"
										variant="outlined"
										margin="normal"
										type="email"
										size="small"
										fullWidth
									/>
									<InputLabel className={styles.mt1}></InputLabel>
									<button
										className={styles.submit}
										type="submit"
										color="primary"
									>
										Continue
									</button>
								</Form>
							</div>
						</div>
					</div>

					<div className={styles.sub}>
						<p className={styles.mt2}>
							<span className={styles.subP}>
								<span className={styles.desc}>Remember your password? </span>
								<a className={styles.signinAnchor} onClick={handleLogin}>
									Back to Login
								</a>
							</span>
						</p>
					</div>
				</div>
			)}
		</Formik>
	);
};

export default LoginPasswordReset;
